// Background remover — the live preview of the media library. Same arithmetic as backend/records/brand_rules.py::remove_background,
// which alone computes the saved image (the browser is never trusted for it).
export const REMOVE_MODES = [["color", "Couleur"], ["ink", "Cachet encre"]];
export const DEFAULT_REMOVAL = { mode: "color", color: "#ffffff", tolerance: 10, softness: 20 };

export function hexToRgb(hex) {
  return [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
}

export function rgbToHex([r, g, b]) {
  return `#${[r, g, b].map((v) => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, "0")).join("")}`;
}

// Opacity (0-255) of a pixel `distance` away from the background colour in colour mode.
export function colorAlpha(distance, tolerance, softness) {
  const threshold = Math.round(tolerance * 2.55);
  const band = Math.max(1, Math.round(softness * 1.5));
  if (distance <= threshold) return 0;
  if (distance >= threshold + band) return 255;
  return Math.round(((distance - threshold) / band) * 255);
}

// Returns a new Uint8ClampedArray of RGBA bytes, or null when nothing would be left.
export function removeBackground(rgba, { mode, color, tolerance, softness }) {
  const key = hexToRgb(color);
  const threshold = Math.round(tolerance * 2.55);
  const count = rgba.length / 4;
  const distances = new Uint8Array(count);
  let peak = 0;
  for (let i = 0; i < count; i += 1) {
    const d = Math.max(Math.abs(rgba[i * 4] - key[0]), Math.abs(rgba[i * 4 + 1] - key[1]), Math.abs(rgba[i * 4 + 2] - key[2]));
    distances[i] = d;
    if (d > peak) peak = d;
  }
  if (mode === "ink" && peak <= threshold) return null;
  let ink = [0, 0, 0];
  if (mode === "ink") {
    const sums = [0, 0, 0];
    let n = 0;
    for (let i = 0; i < count; i += 1) {
      if (distances[i] >= peak * 0.8) {
        sums[0] += rgba[i * 4];
        sums[1] += rgba[i * 4 + 1];
        sums[2] += rgba[i * 4 + 2];
        n += 1;
      }
    }
    ink = sums.map((v) => Math.round(v / Math.max(1, n)));
  }
  const out = new Uint8ClampedArray(rgba.length);
  let kept = 0;
  for (let i = 0; i < count; i += 1) {
    const d = distances[i];
    const fresh = mode === "ink"
      ? (d <= threshold ? 0 : Math.round(Math.min(1, (d - threshold) / (peak - threshold)) * 255))
      : colorAlpha(d, tolerance, softness);
    const alpha = Math.round((fresh * rgba[i * 4 + 3]) / 255);
    const rgb = mode === "ink" ? ink : [rgba[i * 4], rgba[i * 4 + 1], rgba[i * 4 + 2]];
    out[i * 4] = rgb[0];
    out[i * 4 + 1] = rgb[1];
    out[i * 4 + 2] = rgb[2];
    out[i * 4 + 3] = alpha;
    if (alpha > 0) kept += 1;
  }
  return kept === 0 ? null : out;
}
